// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Yedhe","productName":"Table_productName__hr-u7"};